import { render, staticRenderFns } from "./vip_setting_add.vue?vue&type=template&id=2d08ef7c&"
import script from "./vip_setting_add.vue?vue&type=script&lang=ts&"
export * from "./vip_setting_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports